import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import SignInPage from "./pages/SignInPage";
import SignUpPage from "./pages/SignUpPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import ForgotPasswordAppPage from "./pages/ForgotPasswordAppPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import HomePage from "./pages/HomePage";
import OverviewDashboardPage from "./pages/OverviewDashboardPage";
import InviteSignup from "./pages/InviteSignup";
import WorkOrdersDashboardPage from "./pages/WorkOrdersDashboardPage";
import WorkRequestsDashboardPage from "./pages/WorkRequestsDashboardPage";
import FormsDashboardPage from "./pages/FormsDashboardPage";
import UtilisationDashboardPage from "./pages/UtilisationDashboardPage";
import ReliabilityDashboardPage from "./pages/ReliabilityDashboardPage";
import DowntimeDashboardPage from "./pages/DowntimeDashboardPage";
import OperationalDashboardPage from "./pages/OperationalDashboardPage";
import PerformanceDashboardPage from "./pages/PerformanceDashboardPage";
import ApplicationDashboardPage from "./pages/ApplicationDashboardPage";
import BudgetingPage from "./pages/BudgetingPage";
import AddUserPage from "./pages/AddUserPage";
import CompanyPage from "./pages/CompanyPage";
import InvoicePreviewPage from "./pages/InvoicePreviewPage";
import NotificationPage from "./pages/NotificationPage";
import AssetListPage from "./pages/AssetListPage";
import AreaPage from "./pages/AreaPage";
import WorkOrdersPage from "./pages/WorkOrdersPage";
import WorkAssignmentPage from "./pages/WorkAssignmentPage";
import EventsPage from "./pages/EventsPage";
import ShiftLogsPage from "./pages/ShiftLogsPage";
import ViewProfilePage from "./pages/ViewProfilePage";
import RouteScrollToTop from "./helper/RouteScrollToTop";
import MaintenancePage from "./pages/MaintenancePage";
import BlankPagePage from "./pages/BlankPagePage";
import SettingsPage from "./pages/SettingsPage";
import PrivilegesPage from "./pages/PrivilegesPage";
import RolesPage from "./pages/RolesPage";
import UserListPage from "./pages/UserListPage";
import EmailGroupPage from "./pages/EmailGroupPage";
import ContractorsPage from "./pages/ContractorsPage";
import PriorityListPage from "./pages/PriorityListPage";
import CriticalityListPage from "./pages/CriticalityListPage";
import ProtectedRoute from "./components/ProtectedRoute";
import ErrorPage from "./pages/ErrorPage";
import AccessDeniedPage from "./pages/AccessDeniedPage";
import OfflinePage from "./pages/OfflinePage";
import PlanningTypePage from "./pages/PlanningTypePage";
import ClassListPage from "./pages/ClassListPage";
import CostCentrePage from "./pages/CostCentrePage";
import GroupPage from "./pages/GroupPage";
import ManufacturerPage from "./pages/ManufacturerPage";
import PlantStatusPage from "./pages/PlantStatusPage";
import WorkOrderStatusPage from "./pages/WorkOrderStatusPage";
import PartsListPage from "./pages/PartsListPage";
import RotablesPage from "./pages/RotablesPage";
import SupplierListPage from "./pages/SupplierListPage";
import PurchaseOrderPage from "./pages/PurchaseOrderPage";
import PartsCategoryPage from "./pages/PartsCategoryPage";
import CurrencyPage from "./pages/CurrencyPage";
import TradesPage from "./pages/TradesPage";
import ExpenseCodePage from "./pages/ExpenseCodePage";
import CauseCodePage from "./pages/CauseCodePage";
import FailureCodePage from "./pages/FailureCodePage";
import WarehousePage from "./pages/WarehousePage";
import AssetLocationPage from "./pages/AssetLocationPage";
import TeamsListPage from "./pages/TeamsListPage";
import TechniciansPage from "./pages/TechniciansPage";
import StockItemsPage from "./pages/StockItemsPage";
import StocktakesPage from "./pages/StocktakesPage";
import MeasurementUnitsPage from "./pages/MeasurementUnitsPage";
import NotificationsPage from "./pages/NotificationsPage";
import PlanningHorizonPage from "./pages/PlanningHorizonPage";
import MaintenancePlanPage from "./pages/MaintenancePlanPage";
import LlmConfigurationPage from "./pages/LlmConfigurationPage";
import ApiDocsPage from "./pages/ApiDocsPage";
import IntegrationsPage from "./pages/IntegrationsPage";
import TaskTypePage from "./pages/TaskTypePage";
import SetupPage from "./pages/SetupPage";
import WebsitePage from "./pages/WebsitePage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import PlanningGroupPage from "./pages/PlanningGroupPage";
import ExternalServicesPage from "./pages/ExternalServicesPage";
import HierarchyStructurePage from "./pages/HierarchyStructurePage";
import AssetReferencesPage from "./pages/AssetReferencesPage";
import WorkOrderReferencesPage from "./pages/WorkOrderReferencesPage";
import FinanceReferencesPage from "./pages/FinanceReferencesPage";
import GlobalTablesPage from "./pages/GlobalTablesPage";
import DataLoadingPage from "./pages/DataLoadingPage";
import OrganisationPage from "./pages/OrganisationPage";
import TaskReferencesPage from "./pages/TaskReferencesPage";
import PurchasingInventoryReferencesPage from "./pages/PurchasingInventoryReferencesPage";
import FormTablesPage from "./pages/FormTablesPage";
import AssetAssignmentsPage from "./pages/AssetAssignmentsPage";
import PlantRatesPage from "./pages/PlantRatesPage";
import ProjectTablesPage from "./pages/ProjectTablesPage";
import EventTablesPage from "./pages/EventTablesPage";
import MeterListPage from "./pages/MeterListPage";
import AssetMetersPage from "./pages/AssetMetersPage";
import MeterReadingsPage from "./pages/MeterReadingsPage";
import FormsPage from "./pages/FormsPage";
import FormBuilderPage from "./pages/FormBuilderPage";
import FormHistoryPage from "./pages/FormHistoryPage";
import ApprovalWorkflowConfigurationPage from "./pages/ApprovalWorkflowConfigurationPage";
import VisualPlannerPage from "./pages/VisualPlannerPage";
import ComponentManagementPage from "./pages/ComponentManagementPage";
import ComponentPlannerPage from "./pages/ComponentPlannerPage";
import ComponentAnalysisPage from "./pages/ComponentAnalysisPage";
import ComplianceManagementPage from "./pages/ComplianceManagementPage";
import ServiceManagementPage from "./pages/ServiceManagementPage";
import InspectionsManagementPage from "./pages/InspectionsManagementPage";
import ReportsPage from "./pages/ReportsPage";
import MasterLayout from "./masterLayout/MasterLayout";

function App() {
  return (
    <BrowserRouter>
      <RouteScrollToTop />
      <Routes>
        <Route exact path='/sign-in' element={<SignInPage />} />
        <Route exact path='/sign-up' element={<SignUpPage />} />
        <Route exact path='/forgot-password' element={<ForgotPasswordPage />} />
        <Route exact path='/forgot-password-app' element={<ForgotPasswordAppPage />} />
        <Route exact path='/reset-password' element={<ResetPasswordPage />} />
        <Route exact path='/invitesignup' element={<InviteSignup />} />
        <Route exact path='/access-denied' element={<AccessDeniedPage />} />
        <Route exact path='/offline' element={<OfflinePage />} />
        <Route exact path='/website' element={<WebsitePage />} />
        <Route exact path='/privacy-policy' element={<PrivacyPolicyPage />} />
        <Route element={<ProtectedRoute />}>
          <Route element={<MasterLayout />}>
          <Route exact path='/' element={<Navigate to='/home' replace />} />
          <Route exact path='/home' element={<HomePage />} />
          <Route exact path='/dashboards/overview' element={<OverviewDashboardPage />} />
          <Route exact path='/dashboards/application' element={<ApplicationDashboardPage />} />
          <Route exact path='/dashboards/work-orders' element={<WorkOrdersDashboardPage />} />
          <Route exact path='/dashboards/forms' element={<FormsDashboardPage />} />
          <Route exact path='/dashboards/downtime' element={<DowntimeDashboardPage />} />
          <Route exact path='/dashboards/operational' element={<OperationalDashboardPage />} />
          <Route exact path='/dashboards/performance' element={<PerformanceDashboardPage />} />
          <Route exact path='/dashboards/work-requests' element={<WorkRequestsDashboardPage />} />
          <Route exact path='/dashboards/utilisation' element={<UtilisationDashboardPage />} />
          <Route exact path='/dashboards/reliability' element={<ReliabilityDashboardPage />} />
          <Route exact path='/reports' element={<ReportsPage />} />
          <Route exact path='/budgeting' element={<BudgetingPage />} />
          <Route exact path='/settings' element={<SettingsPage />} />
          <Route exact path='/integrations' element={<IntegrationsPage />} />
          <Route exact path='/setup' element={<SetupPage />} />
          <Route exact path='/organisation' element={<OrganisationPage />} />
          <Route exact path='/privileges' element={<PrivilegesPage />} />
          <Route exact path='/roles' element={<RolesPage />} />
          <Route exact path='/user-list' element={<UserListPage />} />
          <Route exact path='/email-group-list' element={<EmailGroupPage />} />
          <Route exact path='/contractors' element={<ContractorsPage />} />
          <Route exact path='/add-user' element={<AddUserPage />} />
          <Route exact path='/company' element={<CompanyPage />} />
          <Route exact path='/maintenance' element={<MaintenancePage />} />
          <Route exact path='/blank-page' element={<BlankPagePage />} />
          <Route exact path='/invoice-preview' element={<InvoicePreviewPage />} />
          <Route exact path='/notification' element={<NotificationPage />} />
          <Route exact path='/view-profile' element={<ViewProfilePage />} />
          <Route exact path='/area' element={<AreaPage />} />
          <Route exact path='/asset-list' element={<AssetListPage />} />
          <Route exact path='/asset-assignments' element={<AssetAssignmentsPage />} />
          <Route exact path='/plant-rates' element={<PlantRatesPage />} />
          <Route exact path='/work-orders' element={<WorkOrdersPage />} />
          <Route exact path='/work-assignment' element={<WorkAssignmentPage />} />
          <Route exact path='/events' element={<EventsPage />} />
          <Route exact path='/shift-logs' element={<ShiftLogsPage />} />
          <Route exact path='/visual-planner' element={<VisualPlannerPage />} />
          <Route exact path='/component-planner' element={<ComponentPlannerPage />} />
          <Route exact path='/component-management' element={<ComponentManagementPage />} />
          <Route exact path='/component-analysis' element={<ComponentAnalysisPage />} />
          <Route exact path='/compliance-management' element={<ComplianceManagementPage />} />
          <Route exact path='/service-management' element={<ServiceManagementPage />} />
          <Route exact path='/inspections-management' element={<InspectionsManagementPage />} />
          <Route exact path='/priority-list' element={<PriorityListPage />} />
          <Route exact path='/criticality-list' element={<CriticalityListPage />} />
          <Route exact path='/class-list' element={<ClassListPage />} />
          <Route exact path='/planning-type-list' element={<PlanningTypePage />} />
          <Route exact path='/cost-centre-list' element={<CostCentrePage />} />
          <Route exact path='/group-list' element={<GroupPage />} />
          <Route exact path='/manufacturer-list' element={<ManufacturerPage />} />
          <Route exact path='/trades-list' element={<TradesPage />} />
          <Route exact path='/plant-status-list' element={<PlantStatusPage />} />
          <Route exact path='/work-order-status-list' element={<WorkOrderStatusPage />} />
          <Route exact path='/task-type-list' element={<TaskTypePage />} />
          <Route exact path='/parts-list' element={<PartsListPage />} />
          <Route exact path='/rotables' element={<RotablesPage />} />
          <Route exact path='/warehouse-list' element={<WarehousePage />} />
          <Route exact path='/supplier-list' element={<SupplierListPage />} />
          <Route exact path='/purchase-orders' element={<PurchaseOrderPage />} />
          <Route exact path='/parts-category-list' element={<PartsCategoryPage />} />
          <Route exact path='/asset-location-list' element={<AssetLocationPage />} />
          <Route exact path='/currency-list' element={<CurrencyPage />} />
          <Route exact path='/expense-code-list' element={<ExpenseCodePage />} />
          <Route exact path='/external-services-list' element={<ExternalServicesPage />} />
          <Route exact path='/cause-codes' element={<CauseCodePage />} />
          <Route exact path='/failure-code-list' element={<FailureCodePage />} />
          <Route exact path='/teams-list' element={<TeamsListPage />} />
          <Route exact path='/technicians-list' element={<TechniciansPage />} />
          <Route exact path='/stock-items' element={<StockItemsPage />} />
          <Route exact path='/stocktakes' element={<StocktakesPage />} />
          <Route exact path='/measurement-units' element={<MeasurementUnitsPage />} />
          <Route exact path='/hierarchy-structure-list' element={<HierarchyStructurePage />} />
          <Route exact path='/notifications' element={<NotificationsPage />} />
          <Route exact path='/planning-horizon' element={<PlanningHorizonPage />} />
          <Route exact path='/planning-group-list' element={<PlanningGroupPage />} />
          <Route exact path='/maintenance-plans' element={<MaintenancePlanPage />} />
          <Route exact path='/llm-config' element={<LlmConfigurationPage />} />
          <Route exact path='/asset-reference' element={<AssetReferencesPage />} />
          <Route exact path='/event-location' element={<EventTablesPage />} />
          <Route exact path='/work-order-reference' element={<WorkOrderReferencesPage />} />
          <Route exact path='/finance-reference' element={<FinanceReferencesPage />} />
          <Route exact path='/purchasing-reference' element={<PurchasingInventoryReferencesPage />} />
          <Route exact path='/task-reference' element={<TaskReferencesPage />} />
          <Route exact path='/form-reference' element={<FormTablesPage />} />
          <Route exact path='/project-reference' element={<ProjectTablesPage />} />
          <Route exact path='/global-reference' element={<GlobalTablesPage />} />
          <Route exact path='/data-loading' element={<DataLoadingPage />} />
          <Route exact path='/meters' element={<MeterListPage />} />
          <Route exact path='/asset-meters' element={<AssetMetersPage />} />
          <Route exact path='/meter-readings' element={<MeterReadingsPage />} />
          <Route exact path='/forms/:id' element={<FormBuilderPage />} />
          <Route exact path='/forms' element={<FormsPage />} />
          <Route exact path='/form-history' element={<FormHistoryPage />} />
          <Route exact path='/approval-workflow-configuration' element={<ApprovalWorkflowConfigurationPage />} />
          <Route exact path='/api-docs' element={<ApiDocsPage />} />
        </Route>
        </Route>
        <Route exact path='*' element={<ErrorPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
